export enum NoteType {
  Crew = 1,
  Passengers = 2,
  DepartureFbo = 3,
  ArrivalFbo = 4,
  PurposeNotes = 5
}
